import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class MedalliaService {
	showFeedBackSurvey(surveyCode: string) {
		window.KAMPYLE_ONSITE_SDK.showForm(surveyCode);
	}

	showLeakSurvey(surveyName: string) {
		window.leak_business_name = surveyName;
		window.KAMPYLE_ONSITE_SDK.updatePageView();
	}
}
